import { useQuery } from '@tanstack/react-query';

import { categoryBreadcrumbsQueryOptions } from '@/modules/breadcrumbs/queryOptions';

export function useCategoryBreadcrumbs({
  categoryPathname,
  linkPrefix,
  enabled,
}: {
  categoryPathname: string;
  linkPrefix?: string;
  enabled?: boolean;
}) {
  return useQuery(
    categoryBreadcrumbsQueryOptions({ categoryPathname, linkPrefix, enabled })
  );
}
